webpackJsonp([70144966829960],{

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(22);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _headerNew = __webpack_require__(26);
	
	var _headerNew2 = _interopRequireDefault(_headerNew);
	
	var _footerNew = __webpack_require__(15);
	
	var _footerNew2 = _interopRequireDefault(_footerNew);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'wrapper--page page--contact' },
	    _react2.default.createElement(_reactHelmet2.default, { title: 'Contact Us - ATTN:' }),
	    _react2.default.createElement(_headerNew2.default, { theme: 'dark' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'contact__hero' },
	      _react2.default.createElement('img', {
	        className: 'contact__hero--desktop',
	        src: data.drupalMedia.image_desktop.url
	      }),
	      _react2.default.createElement('img', {
	        className: 'contact__hero--mobile',
	        src: data.drupalMedia.image_mobile.url
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'wrapper--max-width contact__details' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(
	          'div',
	          { className: 'contact__info' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'General'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:info@attn.com' },
	            'info@attn.com'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'contact__address' },
	            '5700 Wilshire Blvd Suite 375',
	            _react2.default.createElement('br', null),
	            'Los Angeles, CA 90036'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'col' },
	        _react2.default.createElement(
	          'div',
	          { className: 'contact__info' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Press'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:press@attn.com' },
	            'press@attn.com'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'contact__info' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Advertising'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:brands@attn.com' },
	            'brands@attn.com'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'contact__info' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Branded partnerships'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:partnerships@attn.com' },
	            'partnerships@attn.com'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_footerNew2.default, null)
	  );
	}; /* global graphql  */
	
	
	ContactPage.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = ContactPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-532b2848831c8f08bb0b.js